import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { AdPromotionCheck } from '../types';

/** Query options for the cached ad/promotion check of one ad. */
export const getAdPromotionCheckQueryOptions = (adId: string) =>
  queryOptions({
    queryKey: queryKeys.metaAds.promotionCheck(adId),
    queryFn: () =>
      apiClient.get<AdPromotionCheck | null>(
        `meta-ads/${adId}/promotion-check`
      ),
    enabled: !!adId,
    staleTime: 5 * 60 * 1000,
  });

/**
 * Whether the ad's copy and creative agree with the clinic's promotions.
 * Null until the background check has looked at the ad.
 */
export const useGetAdPromotionCheck = (adId: string) => {
  const query = useQuery(getAdPromotionCheckQueryOptions(adId));
  return {
    check: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
